export const environment = {
  production: false,
  apiBasePath: "https://api-stage.dailyedgesports.com/des-api",
  viperRecapAuthDisabled: false,
  stripeDashboardBaseUrl: 'https://dashboard.stripe.com/acct_1SDoF2KGb3f1W29k/test',
  cognito: {
    userPoolId: "us-east-2_D3SjgGujG",
    userPoolWebClientId: "22lr8c6j7qk3uh2dvj1hgf77m9",
  },
};
